// extracted by mini-css-extract-plugin
module.exports = {"related":"style_related__2J-FH","title":"style_title__2zoVU","relatedGrid":"style_relatedGrid__3j0r-"};